import { createContext, useContext } from 'react';
export const MatchTextAreaContext = /*#__PURE__*/createContext(undefined);
const {
  Consumer,
  Provider
} = MatchTextAreaContext;
export { Consumer as MatchTextAreaContextConsumer, Provider as MatchTextAreaContextProvider };
export { Consumer };
export const useMatchTextAreaContext = () => {
  const state = useContext(MatchTextAreaContext);
  if (!state) {
    // If the component is not wrapped in MatchTextAreaProvider, return undefined
    return undefined;
  }
  return state;
};